<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Info</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container pt-0>
            <div class="subheading font-weight-bold mb-3">Game Rules</div>
            <ul class="mb-3">
                <li>No new inning after 1h45m from start time.</li>
                <li>Mercy rule of 10 runs after 5 innings, 7 runs after 6 innings.</li>
                <li>All players bat.</li>
                <li>Free defensive subsutiton.</li>
            </ul>

            <div class="subheading font-weight-bold mb-3">Playoff Rules</div>
            <ul class="mb-3">
                <li>Top 2 teams from each division make the playoffs.</li>
                <li>Best of 3 series.</li>
                <li>Tied matches are determined by extra innings with a runner starting on 2nd base according to OASA rules.</li>
                <li>Players must have played 2 season games to play in the playoffs.</li>
            </ul>

            <div class="subheading font-weight-bold mb-3">Bat Rules</div>
            <ul>
                <li>Acceptable bat stamps as per
                    <a href="https://softball.ca/programs/umpires/approved-bats" target="_blank">Softball Canada</a>.
                </li>
            </ul>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Info'
}
</script>

<style scoped></style>
